import AuthActions from 'auth/AuthActions';
import React from 'react';
import CurrentUser from 'auth/CurrentUser';
import LeadActions from 'actions/LeadActions';
import Tymk from 'user/components/Tymk.jsx';
import UserActions from 'user/UserActions';
import UnauthenticatedView from 'auth/components/UnauthenticatedView.jsx';
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Container from 'components/Container.jsx';
import OrganizationActions from 'actions/OrganizationActions';
import OrganizationStore from 'stores/OrganizationStore';
import ShareRemind from 'user/components/ShareRemind.jsx';
import AppDownloadImageLinks from 'components/AppDownloadImageLinks.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import jwt from 'lib/jsonwebtoken';
import './styles/JoinPageTymkView.scss';

class JoinPageTymkView extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
  };

  static onEnter(nextState, replaceWith, callback) {
    const token = nextState.location.query.token;

    if (token) {
      AuthActions.jwtTokenSignIn(token);
      UserActions.loadCurrentUser(token).then(() => {
        callback();
      });
    }
    callback();
  }

  state = {
    organization: null,
    leads: null,
    showShareRemind: false,
  };

  getChildContext() {
    return {
      eventScreenName: 'invite_teacher_leads_screen',
      eventProperties: {
        total: this.state.leads.length,
        previous_screen_name: 'sms_join',
      },
    };
  }

  componentDidMount() {
    // XXX decoding auth data within a view
    // TODO get these data from the stores
    const payload = jwt.decode(CurrentUser.getToken());

    if (Object.keys(payload).length > 0) {
      const organizationId = payload.organizationId;

      LeadActions.loadLeads().then((leads) => {
        this.setState({ leads });
      }, () => {
        this.setState({ showShareRemind: true });
      });

      OrganizationActions.loadOrganization(organizationId).then(() => {
        const organization = OrganizationStore.getOrganization(organizationId);
        this.setState({ organization });
      }, () => {
        this.setState({ showShareRemind: true });
      });
    } else {
      this.setState({ showShareRemind: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }

  showThanksScreen = () => {
    this.context.router.push('/invite/thanks');
  };

  render() {
    let inviteView;

    if (this.state.showShareRemind) {
      inviteView = <ShareRemind />;
    } else {
      if (!this.state.leads || !this.state.organization) {
        inviteView = <LoadingIndicator />;
      } else {
        inviteView = (
          <Tymk
            triggeredContext="sms_join"
            organizations={[this.state.organization]}
            leads={this.state.leads}
            user={CurrentUser.getUser()}
            afterSendInvitations={this.showThanksScreen}
          />
        );
      }
    }

    return (
      <UnauthenticatedView {...this.props}>
        <Container size="small" className="JoinPageTymkView">
          <Box className="JoinPageTymkView-wrap">
            <BoxBody>
              {inviteView}
            </BoxBody>
          </Box>
          <AppDownloadImageLinks showText />
        </Container>
      </UnauthenticatedView>
    );
  }
}

export default JoinPageTymkView;



// WEBPACK FOOTER //
// ./src/join/components/JoinPageTymkView.jsx